import React from "react";
import { Accordion } from "flowbite-react";
import { Card, ListGroup, ListGroupItem } from "flowbite-react";
import { Button } from "flowbite-react";
import { FaFacebookF } from "react-icons/fa";

export default function Workshop() {
  return (
    <div>
      <h1 className="pt-5 text-center text-4xl font-bold text-[#000000]">
        <strong className="font-bold">
          HOẠT ĐỘNG WORKSHOP TẠI WI_SOL.COFFEE
        </strong>
      </h1>
      <div className="pl-5 pt-10">
        <div>
          <h2 className="pt-5  text-3xl font-semibold text-[#000000]">
            1.WORKSHOP LÀM GỐM
          </h2>
          <p className="pb-4 pt-2 text-xl">
            <strong>-Gốm “ hẹn hò” cùng wi_sol.coffee </strong>
            <br />
          </p>

          <ListGroup>
            <ListGroupItem>
              <p className="text-xl">
                Tìm về chốn riêng dành cho tâm hồn của bạn, nơi chúng ta cùng
                nhau tô vẽ và nhào nặn mọi thứ. Hành trình mẫu đất thô ráp dần
                trở thành một hình hài thú vị cũng là lúc tâm hồn chúng ta dần
                được xoa dịu và an ủi.
              </p>{" "}
              <img
                className="mr-6 h-auto w-1/2"
                src={require("./gom1.JPG")}
                alt="Không gian wi_sol coffee lầu 1"
              />
            </ListGroupItem>
            <ListGroupItem>
              <img
                className="mr-6 h-auto w-1/2"
                src={require("./gom2.JPG")}
                alt="Không gian wi_sol coffee lầu 1"
              />
              <p className="text-xl">
                Tại WiSol Coffee, chúng tôi luôn mong muốn tạo ra những trải
                nghiệm độc đáo và ý nghĩa cho khách hàng. Chính vì vậy, chúng
                tôi tổ chức một workshop làm gốm đặc biệt, nơi bạn có thể thư
                giãn và thả hồn vào những tác phẩm nghệ thuật của mình.
              </p>
            </ListGroupItem>
            <ListGroupItem>
              <div className="grid  grid-rows-1 ">
                <div>
                  <div className="grid grid-cols-2 grid-rows-1">
                    <div className=" border">
                      <p className="pb-5 pl-5 pr-5 pt-5 text-center text-xl font-bold">
                        Thông tin workshop làm gốm thủ công
                      </p>

                      <p className="pb-5 pl-5 pr-5 pt-5 text-left text-xl ">
                        <br /> -Thời gian:
                        <strong> Chủ nhật giữa tháng</strong> <br /> -Địa điểm:
                        quán wi_sol coffee <br /> -Khung thời gian:
                        <strong> 8h-12h</strong> <br /> -Số lượng người tham
                        gia: <strong> 20 người/ca </strong>
                        <br />
                        <br />
                      </p>
                    </div>

                    <div className=" border">
                      <p className="pb-5 pl-5 pr-5 pt-5 text-center text-xl font-bold">
                        {" "}
                        Những trải nghiệm khi tham gia workshop :
                      </p>

                      <p className="pb-5 pl-5 pr-5 pt-5 text-left text-xl ">
                        <br /> -Giao lưu và chia sẻ câu chuyện về đất nung và
                        nghề gốm truyền thống <br /> -Được hướng dẫn tạo hình,
                        nặn gốm với bàn xoay <br /> -Thỏa sức trang trí, tô điểm
                        theo phong cách cá nhân <br /> -Sản phẩm được mang đi
                        tráng men, nung đóng gói để bạn làm quà tặng cho người
                        thân, bạn bè
                      </p>
                    </div>
                  </div>

                  <div>
                    <p className=" pl-5 pr-5 pt-5 text-left text-xl ">
                      Hãy cùng chúng tôi biến những cục đất vô tri trở thành
                      những tác phẩm nghệ thuật đầy ý nghĩa, và để mỗi phút giây
                      tại WiSol Coffee trở thành kỷ niệm đáng nhớ.
                    </p>
                    <p className="pb-5 text-center text-2xl font-bold ">
                      Chúng tôi đang chờ đón bạn!
                    </p>
                  </div>
                </div>
              </div>
            </ListGroupItem>
          </ListGroup>
        </div>

        <div className="pt-20">
          <h2 className="pt-5  text-3xl font-semibold text-[#000000]">
            2.WORKSHOP LÀM NẾN THƠM
          </h2>
          <ListGroup>
            <ListGroupItem>
              <p className="text-xl">
                Bạn thân mến, Workshop làm nến thơm tại wi_sol.coffee là nơi bạn
                có thể gác lại những mệt mỏi và áp lực, để đôi bàn tay dịu dàng
                trang trí nên chiếc nến đặc biệt nhất, để khứu giác được vỗ về
                bởi những mùi hương dễ chịu xua tan mọi mệt mỏi, buồn phiền nhé!
                <br /> Tụi mình ở đây, tại wi_shop.coffee đợi các bạn!
              </p>{" "}
            </ListGroupItem>
            <ListGroupItem>
              <img
                className="-ml-1 mr-2 h-auto  w-1/3"
                src={require("./nen1.JPG")}
                alt="Không gian wi_sol coffee lầu 1"
              />{" "}
              <img
                className="-ml-1 mr-2 h-auto w-1/3"
                src={require("./nen2.JPG")}
                alt="Không gian wi_sol coffee lầu 1"
              />
              <img
                className="-ml-1 mr-1 h-auto w-1/3"
                src={require("./nen3.JPG")}
                alt="Không gian wi_sol coffee lầu 1"
              />
            </ListGroupItem>
            <ListGroupItem>
              <div className="grid  grid-rows-1 ">
                <div>
                  <div className="grid grid-cols-3 grid-rows-1">
                    <div className=" border">
                      <p className="pb-5 pl-5 pr-5 pt-5 text-center text-xl font-bold">
                        Thông tin workshop làm nến thơm
                      </p>

                      <p className="pb-5 pl-5 pr-5 pt-5 text-left text-xl ">
                        -Thời gian:
                        <strong> Chủ nhật cuối tháng </strong> <br /> -Địa điểm:
                        quán wi_sol coffee <br /> -Khung thời gian:
                        <strong> 8h-12h</strong> <br /> -Số lượng người tham
                        gia: <strong> 20 người/ca </strong>
                        <br />
                        <br />
                      </p>
                    </div>

                    <div className=" border">
                      <p className="pb-5 pl-5 pr-5 pt-5 text-center text-xl font-bold">
                        Bạn nhận được gì khi tham gia workshop làm nến thơm:
                      </p>

                      <p className="pb-5 pl-5 pr-5 pt-5 text-left text-xl ">
                        <br /> -Giao lưu và chia sẻ về mùi hương và cách tạo ra
                        một lọ nến thơm <br /> -Được tìm hiểu về nguyên vật
                        liệu, đo lường tạo ra một mùi hương đặc biệt theo sở
                        thích của bản thân <br /> -Thỏa sức trang trí, tô điểm
                        theo phong cách cá nhân <br />
                        -Sau khi hoàn thiện sản phẩm, bạn còn được decor hộp quà
                        với hoa khô và những lời nhắn để dành cho bản thân và
                        những người đặc biệt
                      </p>
                    </div>
                    <div className=" border">
                      <p className="pb-5 pl-5 pr-5 pt-5 text-center text-xl font-bold">
                        Chi phí tham gia làm nến thơm và làm gốm:
                      </p>

                      <p className="pb-5 pl-5 pr-5 pt-5 text-left text-xl ">
                        -Vé 1 người:
                        <strong>249.000vnd/1 người </strong>
                        {"("} đã bao gồm chi phí nguyên vật liệu , tráng men và
                        nung thành phẩm và gọi nước thì được giảm 50%/hóa đơn
                        nước, không cộng gộp{")"} <br /> -Vé đôi
                        <strong> 349.000vnd/2 người </strong> {"("}đã bao gồm
                        chi phí nguyên vật liệu , tráng men và nung thành phẩm
                        và mua 1 nước được tặng 1 nước{")"}
                        <br />
                      </p>
                    </div>
                  </div>

                  <div>
                    <p className="pb-5 pt-5 text-center text-2xl font-bold ">
                      Liên hệ đặt chỗ trước 3 ngày để wi_sol.coffee chuẩn bị chu
                      đáo nhất cho bạn nhé!
                    </p>
                  </div>
                </div>
              </div>
            </ListGroupItem>
          </ListGroup>
        </div>
        <div className="flex flex-wrap justify-center gap-2 pb-10 pt-10">
          <p
            className=" text-left text-3xl "
            href="https://m.me/61562925647117"
          >
            - Liên hệ đặt chỗ qua fanpage
          </p>
          <Button href="https://m.me/61562925647117">{" wi_sol"}</Button>
        </div>
      </div>
    </div>
  );
}
